import React, { useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

interface DropdownProps {
  label: string;
  items: { key: string; value: string; onClick: () => void; disabled?: boolean }[];
  className?: string;
  buttonClassName?: string;
  menuClassName?: string;
  width?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  label,
  items,
  className,
  buttonClassName = 'bg-base-100',
  menuClassName = '',
  width = 'auto',
}) => {
  const detailsRef = useRef<HTMLDetailsElement>(null);

  const handleItemClick = (onClick: () => void) => {
    onClick();
    if (detailsRef.current) {
      detailsRef.current.open = false;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (detailsRef.current && !detailsRef.current.contains(event.target as Node)) {
        detailsRef.current.open = false;
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <details ref={detailsRef} className={`dropdown dropdown-end ${width} ${className || ''}`}>
      <summary
        className={`btn flex w-full items-center justify-between rounded-lg text-sm font-normal text-primary ${buttonClassName}`}
        onClick={(e) => e.stopPropagation()}
      >
        <span>{label}</span>
        <FontAwesomeIcon className="ml-2 h-3 w-3" icon={faChevronDown} />
      </summary>
      <ul className={`menu dropdown-content z-[100] w-full rounded-lg border bg-base-100 p-2 ${menuClassName}`}>
        {items.map(({ key, value, onClick, disabled }) => (
          <li key={key} className={disabled ? 'disabled' : ''}>
            <a
              onClick={(e) => {
                if (!disabled) {
                  e.preventDefault();
                  e.stopPropagation();
                  handleItemClick(onClick);
                }
              }}
              className={disabled ? 'cursor-not-allowed text-gray-400' : ''}
            >
              {value}
            </a>
          </li>
        ))}
      </ul>
    </details>
  );
};

export default Dropdown;
